import { jsx as _jsx } from "react/jsx-runtime";
import CallReceivedIcon from '@mui/icons-material/CallReceived';
import { IconButton, Tooltip } from '@mui/material';
/**
 * RSE — DEVS: DO NOT DELETE THIS, IT WILL NOT DISPLAY FOR USERS!
 */
export const DebugIcon = ({ isAuthenticated, userGroupRoles, pinger }) => {
    return (isAuthenticated &&
        userGroupRoles.groups.includes('\u03BC') && (_jsx(Tooltip, { title: 'Incoming data', children: _jsx("span", { children: _jsx(IconButton, { color: "inherit", disabled: pinger === false, children: _jsx(CallReceivedIcon, {}) }) }) })));
};
